@if (showTargetGraph() || showBehaviorGraph()) {
<div class="supervisor-dialog-backdrop" (click)="hideGraphs()"></div>
<dialog class="supervisor-dialog" open>
  @if (showTargetGraph()) {
  <div style="text-align: center; margin-bottom: 1rem; font-weight: bold; color: white;">
    <h3>Graphs for {{ getTargetName(selectedTarget!.ID!) }}</h3>
  </div>
  <app-target-graph
    [patientID]="session().PatientID?.toString() || ''"
    [selectedTargets]="[selectedTarget!]"
  ></app-target-graph>
  } @if (showBehaviorGraph()) {
    <div style="text-align: center; margin-bottom: 1rem; font-weight: bold; color: white;">
    <h3>Graphs for {{ getBehaviorName(selectedBehavior!.ID!) }}</h3>
  </div>
  <app-behavior-graph
    [patientID]="session().PatientID?.toString() || ''"
    [selectedBehavior]="selectedBehavior"
  ></app-behavior-graph>
  }
</dialog>
}
<mat-tab-group style="width: 100%;">
  <!-- Targets -->
  <mat-tab style="width: 50%;">
    <ng-template mat-tab-label style="margin-bottom: 0px; width: 100%;">
      <p style="width: 100%; text-align: center;">Targets</p>
    </ng-template>
    <p-table [value]="targetsData" dataKey="ID" editMode="row" [attr.inert]="savingData ? '' : null" [loading]="savingData">
      <ng-template pTemplate="header">
        <tr>
          <th *ngIf="!readOnly()">Created By</th>
          <th *ngIf="!readOnly()">Modified By</th>
          <th *ngIf="!readOnly()">Modified Date</th>
          <th>Recorded Date</th>
          <th>Value</th>
          <th>Target Name</th>
          <th>Target Type</th>
          <th *ngIf="!readOnly()" style="width: 2rem"></th>
          <th *ngIf="!readOnly()" style="width: 2rem"></th>
          <th *ngIf="!readOnly()" style="width: 2rem"></th>
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-sessionData
        let-editingSessionData="editing"
        let-sessionDataIndex="rowIndex"
      >
        <tr [pEditableRow]="sessionData">
          <td *ngIf="!readOnly()">
            {{ sessionData.UserFullName || 'N/A' }}
            @if (sessionData.ManuallyAddedDate) {
              <span 
                [pTooltip]="'Added Manually on ' + formatManuallyAddedDate(sessionData.ManuallyAddedDate) + (sessionData.ManuallyAddedByUser ? ' by ' + getUserNameFromViewModel(sessionData.ManuallyAddedByUser) : '')"
                tooltipPosition="right"
                style="margin-left: 5px; display: inline-block; background-color: #3b82f6; color: white; border-radius: 50%; width: 20px; height: 20px; text-align: center; line-height: 20px; font-size: 12px; font-weight: bold; cursor: help;"
              >M</span>
            }
          </td>
          <td *ngIf="!readOnly()">
            {{ sessionData.ModifiedByUser ? getUserNameFromViewModel(sessionData.ModifiedByUser) :  'N/A' }}
          </td>
          <td *ngIf="!readOnly()">
            {{ sessionData.ModifiedDate ? (sessionData.ModifiedDate | date : "MM/dd/yyyy HH:mm") : 'N/A' }}
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="datetime-local"
                  step="1"
                  [(ngModel)]="sessionData.RecordedDate"
                />
              </ng-template>
              <ng-template pTemplate="output">
                {{ sessionData.RecordedDate | date : "MM/dd/yyyy HH:mm" }}
              </ng-template>
            </p-cellEditor>
          </td>

          @if (targetIsPromptBased(sessionData)) { 
            @if (targetIsEchoic(sessionData)) {
              <td>
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <p-dropdown
                      class="pe-1"
                      [options]="promptOptionsForTarget(sessionData)"
                      [(ngModel)]="sessionData.IntValue"
                      [checkmark]="true"
                      optionLabel="text"
                      optionValue="value"
                    />
                    <p-dropdown
                      [options]="extraOptionsForEchoicTarget(sessionData)"
                      [(ngModel)]="sessionData.TextValue"
                      [checkmark]="true"
                      optionLabel="text"
                      optionValue="value"
                    />
                  </ng-template>
                  <ng-template pTemplate="output">
                    <p-tag
                      class="pe-1"
                      [style]="{
                        background: firstColorForEchoic(sessionData)
                      }"
                      [value]="firstTextForEchoic(sessionData)"
                    />
                    <p-tag
                      [style]="{ background: secondColorForEchoic(sessionData) }"
                      [value]="secondTextForEchoic(sessionData)"
                    />
                  </ng-template>
                </p-cellEditor>
              </td>
              } @else {
              <td>
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <p-dropdown
                      [options]="promptOptionsForTarget(sessionData)"
                      [(ngModel)]="sessionData.IntValue"
                      [checkmark]="true"
                      optionLabel="text"
                      optionValue="value"
                    />
                  </ng-template>
                  <ng-template pTemplate="output">
                    <p-tag
                      [style]="{ background: valueColorForTarget(sessionData) }"
                      [value]="valueTextForTarget(sessionData)"
                    />
                  </ng-template>
                </p-cellEditor>
              </td>
              } 
          } @else if (targetIsToileting(sessionData)) {
            <td>
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input
                    pInputText
                    type="text"
                    [(ngModel)]="sessionData.TextValue"
                  />
                  <div class="toileting-checkboxes" style="display: flex; gap: 1rem; margin-top: 0.5rem;">
                    <span>
                      <p-checkbox
                        inputId="session-toileting-urination-on-edit-{{ sessionData.ID }}"
                        [binary]="true"
                        [(ngModel)]="sessionData.ToiletingData.UrinationOn"
                        styleClass="app-checkbox">
                      </p-checkbox>
                      <label for="session-toileting-urination-on-edit-{{ sessionData.ID }}" class="ml-2">Urination On</label>
                    </span>

                    <span>
                      <p-checkbox
                        inputId="session-toileting-urination-off-edit-{{ sessionData.ID }}"
                        [binary]="true"
                        [(ngModel)]="sessionData.ToiletingData.UrinationOff"
                        styleClass="app-checkbox">
                      </p-checkbox>
                      <label for="session-toileting-urination-off-edit-{{ sessionData.ID }}" class="ml-2">Urination Off</label>
                    </span>

                    <span>
                      <p-checkbox
                        inputId="session-toileting-bowel-on-edit-{{ sessionData.ID }}"
                        [binary]="true"
                        [(ngModel)]="sessionData.ToiletingData.BowelMovementOn"
                        styleClass="app-checkbox">
                      </p-checkbox>
                      <label for="session-toileting-bowel-on-edit-{{ sessionData.ID }}" class="ml-2">BM On</label>
                    </span>

                    <span>
                      <p-checkbox
                        inputId="session-toileting-bowel-off-edit-{{ sessionData.ID }}"
                        [binary]="true"
                        [(ngModel)]="sessionData.ToiletingData.BowelMovementOff"
                        styleClass="app-checkbox">
                      </p-checkbox>
                      <label for="session-toileting-bowel-off-edit-{{ sessionData.ID }}" class="ml-2">BM Off</label>
                    </span>

                    <span>
                      <p-checkbox
                        inputId="session-toileting-no-void-edit-{{ sessionData.ID }}"
                        [binary]="true"
                        [(ngModel)]="sessionData.ToiletingData.NoVoid"
                        styleClass="app-checkbox">
                      </p-checkbox>
                      <label for="session-toileting-no-void-edit-{{ sessionData.ID }}" class="ml-2">No Void</label>
                    </span>
                  </div>
                </ng-template>
                <ng-template pTemplate="output">
                  <p-tag
                    [style]="{ background: valueColorForTarget(sessionData) }"
                    [value]="valueTextForTarget(sessionData)"
                  />
                  <div class="toileting-checkboxes" style="display: flex; gap: 1rem; margin-top: 0.5rem;">
                    <span>
                      <p-checkbox
                        inputId="session-toileting-urination-on-view-{{ sessionData.ID }}"
                        [binary]="true"
                        [(ngModel)]="sessionData.ToiletingData.UrinationOn"
                        styleClass="app-checkbox"
                        disabled>
                      </p-checkbox>
                      <label for="session-toileting-urination-on-view-{{ sessionData.ID }}" class="ml-2">Urination On</label>
                    </span>

                    <span>
                      <p-checkbox
                        inputId="session-toileting-urination-off-view-{{ sessionData.ID }}"
                        [binary]="true"
                        [(ngModel)]="sessionData.ToiletingData.UrinationOff"
                        styleClass="app-checkbox"
                        disabled>
                      </p-checkbox>
                      <label for="session-toileting-urination-off-view-{{ sessionData.ID }}" class="ml-2">Urination Off</label>
                    </span>

                    <span>
                      <p-checkbox
                        inputId="session-toileting-bowel-on-view-{{ sessionData.ID }}"
                        [binary]="true"
                        [(ngModel)]="sessionData.ToiletingData.BowelMovementOn"
                        styleClass="app-checkbox"
                        disabled>
                      </p-checkbox>
                      <label for="session-toileting-bowel-on-view-{{ sessionData.ID }}" class="ml-2">BM On</label>
                    </span>

                    <span>
                      <p-checkbox
                        inputId="session-toileting-bowel-off-view-{{ sessionData.ID }}"
                        [binary]="true"
                        [(ngModel)]="sessionData.ToiletingData.BowelMovementOff"
                        styleClass="app-checkbox"
                        disabled>
                      </p-checkbox>
                      <label for="session-toileting-bowel-off-view-{{ sessionData.ID }}" class="ml-2">BM Off</label>
                    </span>

                    <span>
                      <p-checkbox
                        inputId="session-toileting-no-void-view-{{ sessionData.ID }}"
                        [binary]="true"
                        [(ngModel)]="sessionData.ToiletingData.NoVoid"
                        styleClass="app-checkbox"
                        disabled>
                      </p-checkbox>
                      <label for="session-toileting-no-void-view-{{ sessionData.ID }}" class="ml-2">No Void</label>
                    </span>
                  </div>
                </ng-template>
              </p-cellEditor>
            </td>
          } @else if (targetIsWholePartialInterval(sessionData)) {
            <td>
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <p-checkbox
                    [binary]="true"
                    [(ngModel)]="wholePartialIntervalHappened"
                    label="Happened"
                    styleClass="app-checkbox"
                  />
                </ng-template>
                <ng-template pTemplate="output">
                  <p-tag
                    [style]="{ background: valueColorForTarget(sessionData) }"
                    [value]="valueTextForTarget(sessionData)"
                  />
                </ng-template>
              </p-cellEditor>
            </td>
          } @else if (targetIsFluencyRate(sessionData)) {
            <td>
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <div class="d-flex flex-column gap-2">
                    <p-inputNumber
                      autoWidth="false"
                      [style]="{ width: '100%' }"
                      [showButtons]="true"
                      [min]="0"
                      [(ngModel)]="fluencyCorrectCount"
                      placeholder="Correct Count"
                    />
                    <p-inputNumber
                      autoWidth="false"
                      [style]="{ width: '100%' }"
                      [showButtons]="true"
                      [min]="0"
                      [(ngModel)]="fluencyIncorrectCount"
                      placeholder="Incorrect Count"
                    />
                    <p-inputNumber
                      autoWidth="false"
                      [style]="{ width: '100%' }"
                      [showButtons]="true"
                      [min]="0.016667"
                      [minFractionDigits]="1"
                      [maxFractionDigits]="2"
                      suffix=" minutes"
                      [(ngModel)]="fluencyDurationInMinutes"
                      placeholder="Duration"
                    />
                  </div>
                </ng-template>
                <ng-template pTemplate="output">
                  <p-tag
                    [style]="{ background: valueColorForTarget(sessionData) }"
                    [value]="valueTextForTarget(sessionData)"
                  />
                </ng-template>
              </p-cellEditor>
            </td>
          } @else if (targetIsRate(sessionData)) {
            <td>
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <div class="d-flex flex-column gap-2">
                    <p-inputNumber
                      autoWidth="false"
                      [style]="{ width: '100%' }"
                      [showButtons]="true"
                      [min]="0"
                      [(ngModel)]="rateOccurrenceCount"
                      placeholder="Occurrences"
                    />
                    <p-inputNumber
                      autoWidth="false"
                      [style]="{ width: '100%' }"
                      [showButtons]="true"
                      [min]="0.016667"
                      [minFractionDigits]="1"
                      [maxFractionDigits]="2"
                      suffix=" minutes"
                      [(ngModel)]="fluencyDurationInMinutes"
                      placeholder="Duration"
                    />
                  </div>
                </ng-template>
                <ng-template pTemplate="output">
                  <p-tag
                    [style]="{ background: valueColorForTarget(sessionData) }"
                    [value]="valueTextForTarget(sessionData)"
                  />
                </ng-template>
              </p-cellEditor>
            </td>
          } @else if (targetIsDuration(sessionData)) {
            <td>
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <p-inputNumber
                    autoWidth="false"
                    [style]="{ width: '100%' }"
                    [showButtons]="true"
                    [min]="0"
                    [minFractionDigits]="1"
                    [maxFractionDigits]="2"
                    suffix=" minutes"
                    [(ngModel)]="targetDurationInMinutes"
                  />
                </ng-template>
                <ng-template pTemplate="output">
                  <p-tag
                    [style]="{ background: valueColorForTarget(sessionData) }"
                    [value]="valueTextForTarget(sessionData)"
                  />
                </ng-template>
              </p-cellEditor>
            </td>
          } @else if (targetIsIntensity(sessionData)) {
            <td>
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <p-selectButton
                    [(ngModel)]="sessionData.IntValue"
                    [options]="targetIntensityOptions(sessionData)"
                    optionLabel="label"
                    optionValue="value"
                  />
                </ng-template>
                <ng-template pTemplate="output">
                  <p-tag
                    [style]="{ background: valueColorForTarget(sessionData) }"
                    [value]="valueTextForTarget(sessionData)"
                  />
                </ng-template>
              </p-cellEditor>
            </td>
          }
           @else {            
            <td>
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input
                    pInputText
                    type="text"
                    [(ngModel)]="sessionData.TextValue"
                  />
                </ng-template>
                <ng-template pTemplate="output">
                  <p-tag
                    [style]="{ background: valueColorForTarget(sessionData) }"
                    [value]="valueTextForTarget(sessionData)"
                  />
                </ng-template>
              </p-cellEditor>
            </td>
          }

          <td>
            {{ getTargetName(sessionData.PatientTargetID) }}
          </td>
          <td>
            {{ getTargetType(sessionData.PatientTargetID) }}
          </td>
          <td *ngIf="!readOnly()">
            <div class="flex align-items-center justify-content-center gap-2">
              <button
                *ngIf="!readOnly() && !editingSessionData"
                pButton
                pRipple
                type="button"
                pInitEditableRow
                icon="pi pi-pencil"
                (click)="onSessionDataEditInit(sessionData)"
                class="p-button-rounded p-button-text"
              ></button>
              <button
                *ngIf="editingSessionData"
                pButton
                pRipple
                type="button"
                pSaveEditableRow
                icon="pi pi-check"
                (click)="onSessionDataEditSave(sessionData)"
                class="p-button-rounded p-button-text p-button-success mr-2"
              ></button>
              <button
                *ngIf="editingSessionData"
                pButton
                pRipple
                type="button"
                pCancelEditableRow
                icon="pi pi-times"
                (click)="onSessionDataEditCancel(sessionData)"
                class="p-button-rounded p-button-text p-button-danger"
              ></button>
            </div>
          </td>
          <td *ngIf="!readOnly()">
            <button
              *ngIf="!readOnly() && !editingSessionData"
              pButton
              pRipple
              type="button"
              icon="pi pi-chart-bar"
              (click)="onShowTargetGraphClicked(sessionData.PatientTargetID)"
              (disabled)="canPlotTargetGraph(sessionData.PatientTargetID)"
              class="p-button-rounded p-button-text"
            ></button>
          </td>
          <td *ngIf="!readOnly()">
            <button
              *ngIf="!editingSessionData && canDeleteSessionData(sessionData)"
              pButton
              pRipple
              type="button"
              icon="pi pi-trash"
              (click)="onSessionDataDelete(sessionData)"
              class="p-button-rounded p-button-text p-button-danger"
            ></button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="readOnly() ? 4 : 10">There are no Target entries for this session.</td>
        </tr>
      </ng-template>
    </p-table>
  </mat-tab>
  <!-- Behaviors -->
  <mat-tab style="width: 50%;">
    <ng-template mat-tab-label style="margin-bottom: 0px; width: 100%;">
      <p style="width: 100%; text-align: center;">Behaviors</p>
    </ng-template>
    <p-table
      [attr.inert]="savingData ? '' : null"
      [loading]="savingData"
      [value]="behaviorsData"
      dataKey="ID"
      editMode="row"
      (onRowExpand)="onBehaviorsRowExpand($event)"
      (onRowCollapse)="onBehaviorsRowCollapse($event)"
      [rowHover]="true"
    >
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 5rem"></th>
          <th *ngIf="!readOnly()">Created By</th>
          <th *ngIf="!readOnly()">Modified By</th>
          <th *ngIf="!readOnly()">Modified Date</th>
          <th>Recorded Date</th>
          <th>Behavior</th>
          <th>Text Value</th>
          <th>Notes</th>
          <th *ngIf="!readOnly()" style="width: 2rem"></th>
          <th *ngIf="!readOnly()" style="width: 2rem"></th>
          <th *ngIf="!readOnly()" style="width: 2rem"></th>
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-sessionData
        let-editingSessionData="editing"
        let-expanded="expanded"
        let-sessionDataIndex="rowIndex"
      >
        <tr [pEditableRow]="sessionData">
          <td>
            <p-button
              type="button"
              pRipple
              [pRowToggler]="sessionData"
              [text]="true"
              [rounded]="true"
              [plain]="true"
              [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
            />
          </td>
          <td *ngIf="!readOnly()">
            {{ sessionData.UserFullName || 'N/A' }}
            @if (sessionData.ManuallyAddedDate) {
              <span 
                [pTooltip]="'Added Manually on ' + formatManuallyAddedDate(sessionData.ManuallyAddedDate) + (sessionData.ManuallyAddedByUser ? ' by ' + getUserNameFromViewModel(sessionData.ManuallyAddedByUser) : '')"
                tooltipPosition="right"
                style="margin-left: 5px; display: inline-block; background-color: #3b82f6; color: white; border-radius: 50%; width: 20px; height: 20px; text-align: center; line-height: 20px; font-size: 12px; font-weight: bold; cursor: help;"
              >M</span>
            }
          </td>
          <td *ngIf="!readOnly()">
            {{ sessionData.ModifiedByUser ? getUserNameFromViewModel(sessionData.ModifiedByUser) : 'N/A' }}
          </td>
          <td *ngIf="!readOnly()">
            {{ sessionData.ModifiedDate ? (sessionData.ModifiedDate | date : "MM/dd/yyyy HH:mm") : 'N/A' }}
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="datetime-local"
                  step="1"
                  [(ngModel)]="sessionData.RecordedDate"
                />
              </ng-template>
              <ng-template pTemplate="output">
                {{ sessionData.RecordedDate | date : "MM/dd/yyyy HH:mm" }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            {{ getBehaviorName(sessionData.PatientBehaviorID) }}
          </td>
          @if (behaviorIsDuration(sessionData)) {
            <td>
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <p-inputNumber
                    autoWidth="false"
                    [style]="{ width: '100%' }"
                    [showButtons]="true"
                    [min]="0"
                    [minFractionDigits]="1"
                    [maxFractionDigits]="2"
                    suffix=" minutes"
                    [(ngModel)]="behaviorDurationInMinutes"
                  />
                </ng-template>
                <ng-template pTemplate="output">
                  {{ secondsToFormattedString(sessionData.IntValue ?? 0) }}
                </ng-template>
              </p-cellEditor>
            </td>
          } @else if (behaviorIsIntensity(sessionData)) {
            <td>
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <p-selectButton
                    [(ngModel)]="sessionData.IntValue"
                    [options]="behaviorIntensityOptions(sessionData)"
                    optionLabel="label"
                    optionValue="value"
                  />
                </ng-template>
                <ng-template pTemplate="output">
                  {{ sessionData.IntValue }}
                </ng-template>
              </p-cellEditor>
            </td>
          } @else {
            <td>
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input
                    pInputText
                    type="text"
                    [(ngModel)]="sessionData.TextValue"
                  />
                </ng-template>
                <ng-template pTemplate="output">
                  {{ sessionData.TextValue }}
                </ng-template>
              </p-cellEditor>
            </td>
          }
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input pInputText type="text" [(ngModel)]="sessionData.Notes" />
              </ng-template>
              <ng-template pTemplate="output">
                {{ sessionData.Notes }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td *ngIf="!readOnly()">
            <div class="flex align-items-center justify-content-center gap-2">
              <button
                *ngIf="!readOnly() && !editingSessionData"
                pButton
                pRipple
                type="button"
                pInitEditableRow
                icon="pi pi-pencil"
                (click)="onSessionDataEditInit(sessionData)"
                class="p-button-rounded p-button-text"
              ></button>
              <button
                *ngIf="editingSessionData"
                pButton
                pRipple
                type="button"
                pSaveEditableRow
                icon="pi pi-check"
                (click)="onSessionDataEditSave(sessionData)"
                class="p-button-rounded p-button-text p-button-success mr-2"
              ></button>
              <button
                *ngIf="editingSessionData"
                pButton
                pRipple
                type="button"
                pCancelEditableRow
                icon="pi pi-times"
                (click)="onSessionDataEditCancel(sessionData)"
                class="p-button-rounded p-button-text p-button-danger"
              ></button>
            </div>
          </td>
          <td *ngIf="!readOnly()">
            <button
              *ngIf="!readOnly() && !editingSessionData"
              pButton
              pRipple
              type="button"
              icon="pi pi-chart-bar"
              (click)="
                onShowBehaviorGraphClicked(sessionData.PatientBehaviorID)
              "
              class="p-button-rounded p-button-text"
            ></button>
          </td>
          <td *ngIf="!readOnly()">
            <button
              *ngIf="!editingSessionData && canDeleteSessionData(sessionData)"
              pButton
              pRipple
              type="button"
              icon="pi pi-trash"
              (click)="onSessionDataDelete(sessionData)"
              class="p-button-rounded p-button-text p-button-danger"
            ></button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="expandedrow" let-sessionData>
        <tr>
          <td [attr.colspan]="readOnly() ? 5 : 11">
            <div class="p-3">
              <p-table
                [value]="[sessionData]"
                dataKey="ID"
                editMode="row"
                [rowHover]="true"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th>Antecedents</th>
                    <th>Consequences</th>
                    <th>Location</th>
                    <th>Response</th>
                    <th>Severity</th>
                    <th *ngIf="!readOnly()" style="width: 4rem"></th>
                  </tr>
                </ng-template>
                <ng-template
                  pTemplate="body"
                  let-sessionData
                  let-editingSessionData="editing"
                  let-sessionDataIndex="rowIndex"
                >
                  <tr [pEditableRow]="sessionData">
                    <td>
                      <p-cellEditor>
                        <ng-template pTemplate="input">
                          <p-multiSelect
                            appendTo="body"
                            [showClear]="true"
                            [options]="behaviorAntecedentsOptions()"
                            [(ngModel)]="
                              sessionData.PatientBehaviorAntecedentIDs
                            "
                            optionLabel="text"
                            optionValue="value"
                          />
                        </ng-template>
                        <ng-template pTemplate="output">
                          {{
                            getAntecedentsLabelsName(
                              sessionData.PatientBehaviorAntecedentIDs,
                              sessionData.PatientBehaviorAntecedentOther
                            )
                          }}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td>
                      <p-cellEditor>
                        <ng-template pTemplate="input">
                          <p-multiSelect
                            appendTo="body"
                            [showClear]="true"
                            [options]="behaviorConsequencesOptions()"
                            [(ngModel)]="
                              sessionData.PatientBehaviorConsequenceIDs
                            "
                            optionLabel="text"
                            optionValue="value"
                          />
                        </ng-template>
                        <ng-template pTemplate="output">
                          {{
                            getConsequencesLabelsName(
                              sessionData.PatientBehaviorConsequenceIDs,
                              sessionData.PatientBehaviorConsequenceOther
                            )
                          }}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td>
                      <p-cellEditor>
                        <ng-template pTemplate="input">
                          <p-dropdown
                            appendTo="body"
                            [options]="behaviorLocationsOptions()"
                            [(ngModel)]="sessionData.PatientBehaviorLocationID"
                            [checkmark]="true"
                            optionLabel="text"
                            optionValue="value"
                            [showClear]="true"
                          />
                        </ng-template>
                        <ng-template pTemplate="output">
                          {{
                            getLocationName(
                              sessionData.PatientBehaviorLocationID
                            )
                          }}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td>
                      <p-cellEditor>
                        <ng-template pTemplate="input">
                          <p-dropdown
                            appendTo="body"
                            [options]="behaviorResponsesOptions()"
                            [(ngModel)]="sessionData.PatientBehaviorResponseID"
                            [checkmark]="true"
                            optionLabel="text"
                            optionValue="value"
                            [showClear]="true"
                          />
                        </ng-template>
                        <ng-template pTemplate="output">
                          {{
                            getResponseName(
                              sessionData.PatientBehaviorResponseID
                            )
                          }}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td>
                      <p-cellEditor>
                        <ng-template pTemplate="input">
                          <p-dropdown
                            appendTo="body"
                            [options]="behaviorSeveritiesOptions()"
                            [(ngModel)]="sessionData.PatientBehaviorSeverityID"
                            [checkmark]="true"
                            optionLabel="text"
                            optionValue="value"
                            [showClear]="true"
                          />
                        </ng-template>
                        <ng-template pTemplate="output">
                          {{
                            getSeverityName(
                              sessionData.PatientBehaviorSeverityID
                            )
                          }}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td *ngIf="!readOnly()">
                      <div
                        class="flex align-items-center justify-content-center gap-2"
                      >
                        <button
                          *ngIf="!readOnly() && !editingSessionData"
                          pButton
                          pRipple
                          type="button"
                          pInitEditableRow
                          icon="pi pi-pencil"
                          (click)="onSessionDataEditInit(sessionData)"
                          class="p-button-rounded p-button-text"
                        ></button>
                        <button
                          *ngIf="editingSessionData"
                          pButton
                          pRipple
                          type="button"
                          pSaveEditableRow
                          icon="pi pi-check"
                          (click)="onSessionDataEditSave(sessionData)"
                          class="p-button-rounded p-button-text p-button-success mr-2"
                        ></button>
                        <button
                          *ngIf="editingSessionData"
                          pButton
                          pRipple
                          type="button"
                          pCancelEditableRow
                          icon="pi pi-times"
                          (click)="onSessionDataEditCancel(sessionData)"
                          class="p-button-rounded p-button-text p-button-danger"
                        ></button>
                      </div>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="readOnly() ? 5 : 11">There are no Behavior entries for this session.</td>
        </tr>
      </ng-template>
    </p-table>
  </mat-tab>
</mat-tab-group>
